import { useState } from 'react';

import cs from 'classnames';

import Button from 'components/shared/Button/Button';
import Input from 'components/shared/Input/Input';
import Confirm from 'components/shared/Modal/Confirm/Confirm';

const FaxSection = ({ formik, copyToClipboard, setupFax, isPending }) => {
  const [showGenerateFaxModal, setShowGenerateFaxModal] = useState(false);

  const handleGenerateFax = () => {
    setupFax();
    setShowGenerateFaxModal(false);
  };

  return (
    <div>
      <p className="text-base font-600 text-neutral-900">eFax</p>
      <p className="mb-4 text-sm text-neutral-600">Send and receive e-faxes from Myriad.</p>
      <div className="grid grid-cols-2 gap-4 sm:grid-cols-1 md:grid-cols-2">
        {formik.values.fax ? (
          <Input
            data-qa="practice-fax-number"
            name="e-Fax"
            value={formik.values.fax}
            onChange={formik.handleChange}
            icon="copy-mono"
            iconClick={() => copyToClipboard(formik.values.fax)}
          />
        ) : (
          <Button
            style="outlined"
            icon="add-square-mono"
            iconSize={18}
            iconColor="neutral-200"
            isDisabled={isPending}
            isLoading={isPending}
            onClick={() => setShowGenerateFaxModal(true)}
            textClassName="!normal-case"
            text="Generate new eFax number"
            className={cs(
              'h-[48px] w-full !justify-start border-neutral-200 bg-white !px-3 text-neutral-800',
              isPending && 'bg-transparent'
            )}
          />
        )}
      </div>

      <Confirm
        icon="info-circle-filled"
        iconColor="primary"
        variant="primary"
        isOpen={showGenerateFaxModal}
        handleClose={() => setShowGenerateFaxModal(false)}
        title="Generate eFax number?"
        message="Generating a new e-Fax number will assign a unique Myriad fax line to your practice. This number can be used immediately for sending and receiving faxes through Myriad Health."
        footerActions={{
          primary: {
            text: 'Generate',
            onClick: handleGenerateFax,
            isLoading: isPending
          }
        }}
      />
    </div>
  );
};

export default FaxSection;
